module.exports = __webpack_public_path__ + "media/kiminoto.a23447fa.mp3";